import script from "./MarkNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkNode.vue?vue&type=script&setup=true&lang=ts"

import "./MarkNode.vue?vue&type=style&index=0&id=c476c56a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c476c56a"]])

export default __exports__